/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting publish..." |
*
* @param {Work_Order_Publish_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_starting = /** @type {((inputs?: Work_Order_Publish_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de la publication...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veröffentlichung wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio pubblicazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало публикации...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Empezando a publicar...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始发布……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開を開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a publicação...")
	return /** @type {LocalizedString} */ ("Starting publish...")
});